import types from '../../constants';
import auth from '../../auth';
import {I18n} from 'react-redux-i18n';

import download from '../../assets/js/download';
import moment from "moment";
import download2 from '../../assets/js/download';
import {fetchCompanies} from "../Companies/CompaniesActions";
import helpers from '../../helpers';

export function setUpdateFlag(value) {
  return {
    type: types.SCENARIOS_SET_UPDATE_FLAG,
    payload: value,
  };
}

export function openModal() {
  return {
    type: types.SCENARIOS_CHANGE_MODAL_STATE,
    payload: true,
  };
}

export function closeModal() {
  return {
    type: types.SCENARIOS_CHANGE_MODAL_STATE,
    payload: false,
  };
}

export function setError(value) {
  return {
    type: types.SCENARIOS_SET_ERROR_MESSAGE,
    payload: value,
  };
}

export function closeError() {
  return {type: types.SCENARIOS_CLOSE_ERROR};
}

export function selectScenario(value) {
  return {
    type: types.SCENARIOS_SELECT,
    payload: value,
  };
}

export function selectRepository(value) {
  return async (dispatch) => {
    dispatch({
      type: types.SCENARIOS_SELECT_REPO,
      payload: value,
    });

    dispatch(fetchRepoScenarios(value));
  }
}

export function selectRepoSim(value) {
  return {
    type: types.SCENARIOS_SELECT_REPO_SIM,
    payload: value,
  };
}

export function importRepoSim(compId, simId) {
  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_LOAD_START});

    fetch('/api/companies/import-repo-sim', {
      method: 'POST',
      body: JSON.stringify({
        company_id: compId,
        scenario_id: simId,
      }),
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        "Content-Type": "application/json",
        Authorization: localStorage.token,
      },
    }).then((response) => {
      dispatch({type: types.SCENARIOS_LOAD_END});

      if (response.status === 400) {
        return alert(response.error);
      }

      dispatch(fetchScenarios());
    })
  }
}

export function fetchScenarios(filter) {
  const user = helpers.getUserFromLocalStorage();
  if (!user) return auth.logoutAndRedirect();

  let url = '/api/scenarios';

  if (filter && filter.company) {
    url += `/${filter.company}`;
  } else {
    url += `/${user.company._id}`;
  }

  if (filter && filter.name) {
    url += `?name=${filter.name}`;
  }

  return async (dispatch, getState) => {
    const { scenarios: { currentScenario } } = getState();
    dispatch({type: types.SCENARIOS_FETCH_START});
    fetch(url, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        dispatch({type: types.SCENARIOS_CLEAR_ERROR});
        dispatch({
          type: types.SCENARIOS_FETCH_END,
          payload: data.scenarios,
        });
        if(currentScenario) {
          const match = data.scenarios.find((scenario) => scenario._id === currentScenario);
          if(match) {
            dispatch(selectScenario({_id: currentScenario, mapInfo: match.mapInfo}));
          }
        }
      })
      .catch((err) => {
        console.log('Error:', err); // eslint-disable-line
        dispatch({
          type: types.SCENARIOS_SET_ERROR_MESSAGE,
          payload: 'Unable to fetch scenarios.',
        });
      });

    return true;
  };
}

export function addRepo(name, accessCode) {
  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_LOAD_START});

    fetch('/api/companies/add-repo', {
      method: 'POST',
      body: JSON.stringify({
        company: name,
        access_key: accessCode
      }),
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        "Content-Type": "application/json",
        Authorization: localStorage.token,
      },
    }).then((response) => {
      dispatch({type: types.SCENARIOS_LOAD_END});

      if (response.status === 400) {
        return alert(response.error);
      }

      dispatch(fetchRepos());
    })
  }
}

export function fetchRepos() {
  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_FETCH_REPOS_START});
    fetch('/api/companies/fetch-repos', {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    }).then(response => {
      if (response.status === 400) {
        dispatch({type: types.SCENARIOS_FETCH_REPOS_END, payload: []});
        return alert(response.error);
      }

      return response.json()
        .then(repos => {
          dispatch({type: types.SCENARIOS_FETCH_REPOS_END, payload: repos});
        });
    })
  };
}

export function fetchRepoScenarios(id) {
  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_FETCH_REPO_START});
    if (!id) {
      return dispatch({type: types.SCENARIOS_FETCH_REPO_END, payload: []});
    }
    fetch('/api/companies/fetch-repo-details/' + id, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    }).then(response => {
      if (response.status === 400) {
        dispatch({type: types.SCENARIOS_FETCH_REPO_END, payload: []});
        return alert(response.error);
      }

      return response.json()
        .then(company => {
          dispatch({type: types.SCENARIOS_FETCH_REPO_END, payload: company.scenarios});
        });
    })
  };
}

export function removeRepo(company_id) {
  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_LOAD_START});

    fetch('/api/companies/remove-repo', {
      method: 'POST',
      body: JSON.stringify({company_id}),
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        "Content-Type": "application/json",
        Authorization: localStorage.token,
      },
    }).then((response) => {
      dispatch({type: types.SCENARIOS_LOAD_END});
      dispatch({type: types.SCENARIOS_SELECT_REPO, payload: null});
      dispatch({type: types.SCENARIOS_FETCH_REPO_END, payload: []});

      if (response.status === 400) {
        return alert(response.error);
      }

      dispatch(fetchRepos());
    })
  }
}

export function renameScenario(companyId, scenarioId, newId, newTitle) {

  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_LOAD_START});

    const params = {
      url: `/api/scenarios/${companyId}/${scenarioId}/rename`,
      method: 'POST',
    };

    fetch(params.url, {
      method: params.method,
      body: JSON.stringify({
        newId,
        newTitle
      }),
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        "Content-Type": "application/json",
        Authorization: localStorage.token,
      },
    }).then((response) => {
      dispatch({type: types.SCENARIOS_LOAD_END});

      if (response.status === 400) {
        return alert(response.error);
      }

      dispatch(fetchScenarios({company: companyId}));
    })
  }
}

export function saveScenarioMap(companyId, scenarioId, mapImage, mapLocations) {

  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_LOAD_START});

    let formData = new FormData();

    formData.append("mapImage", mapImage);
    formData.append("mapLocations", JSON.stringify(mapLocations));

    fetch(`/api/scenarios/${companyId}/${scenarioId}/savemap`, {
      method: 'POST',
      body: formData,
      headers: {
        pragma: 'no-cache',
        Authorization: localStorage.token,
      },
    }).then((response) => {
      dispatch({type: types.SCENARIOS_LOAD_END});

      if (response.status === 400) {
        return response.json();
      }

      dispatch(fetchScenarios({company: companyId}));
    })
    .then((data) => {
      if(data) {
        alert(data.error);
      }
    })
  }
}

export function makePublicScenario(filter, scenarioId) {

  return async (dispatch) => {
    const user = helpers.getUserFromLocalStorage();
    dispatch({type: types.SCENARIOS_LOAD_START});
    const companyId = filter.company || user.company._id;

    const params = {
      url: `/api/scenarios/${companyId}/${scenarioId}/make_public`,
      method: 'GET',
    };

    fetch(params.url, {
      method: params.method,
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        "Content-Type": "application/json",
        Authorization: localStorage.token,
      },
    }).then((response) => {
      dispatch({type: types.SCENARIOS_LOAD_END});

      if (response.status === 400) {
        return alert(response.error);
      }

      dispatch(fetchScenarios(filter));
    })
  }
}

export function makeUnpublicScenario(filter, scenarioId) {

  return async (dispatch) => {
    const user = helpers.getUserFromLocalStorage();
    dispatch({type: types.SCENARIOS_LOAD_START});
    const companyId = filter.company || user.company._id;

    const params = {
      url: `/api/scenarios/${companyId}/${scenarioId}/make_unpublic`,
      method: 'GET',
    };

    fetch(params.url, {
      method: params.method,
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        "Content-Type": "application/json",
        Authorization: localStorage.token,
      },
    }).then((response) => {
      dispatch({type: types.SCENARIOS_LOAD_END});

      if (response.status === 400) {
        return alert(response.error);
      }

      dispatch(fetchScenarios(filter));
    })
  }
}

export function uploadScenario(company, file, uniqueId) {
  const user = helpers.getUserFromLocalStorage();
  if (!user) return auth.logoutAndRedirect();

  const formData = new FormData();
  formData.append('scenario', file);

  const companyId = company || user.company._id;

  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_UPLOAD_START});

    const params = {
      url: `/api/scenarios/${companyId}`,
      method: 'POST',
    };

    if (uniqueId) {
      params.url = `${params.url}/${uniqueId}`;
      params.method = 'PUT';
    }

    fetch(params.url, {
      method: params.method,
      body: formData,
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then(response =>
        new Promise((resolve, reject) => {
          if (response.status === 403 || response.status === 401) {
            alert(I18n.t('scenarios.UpdatedUnsuccessfully'));
            auth.logoutAndRedirect();
            return reject('Not authenticated.');
          }

          if (response.status === 404) {
            alert(I18n.t('scenarios.UpdatedUnsuccessfully'));
            return reject('Scenario has to be of same ID.');
          }

          if (response.status === 400) {
            alert(I18n.t('scenarios.UpdatedUnsuccessfully'));
            return response.json()
              .then(resp => reject(resp.error));
          }

          alert(I18n.t('scenarios.UpdatedSuccessfully'));
          dispatch({type: types.SCENARIOS_CLEAR_ERROR});
          dispatch({type: types.SCENARIOS_UPLOAD_END});
          dispatch(fetchScenarios({company}));
          return resolve();
        }))
      .catch((err) => {
        console.log('Error:', err); // eslint-disable-line
        dispatch({
          type: types.SCENARIOS_SET_ERROR_MESSAGE,
          payload: err || 'Unable to upload scenario.',
        });
        dispatch({type: types.SCENARIOS_UPLOAD_END});
      });

    return true;
  };
}

export function deleteScenario(company, scenarioId) {
  const user = helpers.getUserFromLocalStorage();
  if (!user) return auth.logoutAndRedirect();

  const companyId = company || user.company._id;

  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_DELETE_START});

    fetch(`/api/scenarios/${companyId}/${scenarioId}`, {
      method: 'DELETE',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.blob();
      })
      .then(() => {
        dispatch(fetchScenarios({company}));
        dispatch({type: types.SCENARIOS_CLEAR_ERROR});
        dispatch({type: types.SCENARIOS_DELETE_END});
      })
      .catch((err) => {
        dispatch({type: types.SCENARIOS_DELETE_END});
        console.log('err!', err); // eslint-disable-line
      });

    return true;
  };
}

export function downloadScenario(company, uniqueId) {
  const user = helpers.getUserFromLocalStorage();
  if (!user) return auth.logoutAndRedirect();

  const companyId = company || user.company._id;

  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_DOWNLOAD_START});

    let url = `/api/scenarios/${companyId}/${uniqueId}/download`;

    let fetching;

    fetch(`/api/scenarios/${companyId}/${uniqueId}/getlink`, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then(response => response.text())
      .then(link => {
        fetching = fetch(link, {
          method: 'GET',
          headers: {
            pragma: 'no-cache',
            Accept: 'application/json',
          },
        })
          .then((response) => {
            if (response.status === 403 || response.status === 401) {
              auth.logoutAndRedirect();
              throw new Error('Not authenticated.');
            }
            return response.blob();
          })
          .then((data) => {
            if (data) {
              download(data, 'scenario.zip', 'application/octet-stream');
            }
            dispatch({type: types.SCENARIOS_CLEAR_ERROR});
            dispatch({type: types.SCENARIOS_DOWNLOAD_END});
          })
          .catch((err) => {
            dispatch({type: types.SCENARIOS_DOWNLOAD_END});
            console.log('err!', err); // eslint-disable-line
          });
      })

    return true;
  };
}

export function changeFilter(key, value) {
  return {
    type: types.SCENARIOS_CHANGE_FILTER,
    payload: {
      key,
      value,
    },
  };
}

export function resetFilter() {
  return {type: types.SCENARIOS_RESET_FILTER};
}

export function exportCompanyScenarios() {
  return async (dispatch) => {
    let url = '/api/companies/export-company-scenarios';
    dispatch({type: types.SCENARIOS_LOAD_START});
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/zip',
        Authorization: localStorage.token,
        'Content-Type': 'application/json'
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.blob();
      })
      .then(blob => {
        dispatch({
          type: types.SCENARIOS_LOAD_END,
        });

        let title = `export-${new moment().format('MM-DD-YYYY')}.zip`;
        download2(blob, title, 'application/zip');

      })
  }
}


export function importCompanyScenarios(file, isRewriting) {
  return async (dispatch) => {
    dispatch({type: types.SCENARIOS_LOAD_START});
    let body = new FormData();
    body.append('importFile', file);
    body.append('isRewriting', isRewriting);
    fetch('/api/companies/import-company-scenarios', {
      method: 'POST',
      body,
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => new Promise((resolve, reject) => {
        if (response.status === 200) {
          alert('Successfully imported');

          dispatch({
            type: types.SCENARIOS_LOAD_END,
          });
          resolve();
        }
        else if (response.status === 400) {
          return response.json()
            .then(resp => {
              if (resp.error === "Overwrite permission required") {
                let scenariosString = ': \n';
                resp.scenarios.forEach((s, i) => scenariosString += `${i + 1}. ${s.title} (${s.id}), \n`);
                scenariosString = scenariosString.slice(0, -3);

                if (confirm('Import will rewrite existing sims' + scenariosString + '. \n\nContinue?')) {
                  importCompanyScenarios(file, true)(dispatch);
                }
                else {
                  dispatch({type: types.SCENARIOS_LOAD_END});
                }
              }
              else {
                reject(resp.error);
              }
            });
        }
        else if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }
      }))
      .then(() => {
        setTimeout(() => {
          fetchScenarios()(dispatch)
        }, 500)
      })
      .catch((err) => {
        console.log('Error:', err); // eslint-disable-line
        dispatch({
          type: types.SCENARIOS_SET_ERROR_MESSAGE,
          payload: err || 'Unable to upload scenario.',
        });
        dispatch({type: types.SCENARIOS_LOAD_END});
      });

  }
}

export function openMapEditor(mapInfo) {
  return async (dispatch) => {
    dispatch({
      type: types.SCENARIOS_MAPEDITOR_TOGGLE,
      payload: true
    })
  }
}

export function closeMapEditor(mapInfo) {
  return async (dispatch) => {
    dispatch({
      type: types.SCENARIOS_MAPEDITOR_TOGGLE,
      payload: false
    })
  }
}
